import dayjs from 'dayjs';


export const format_date = (value, format_str) => {
	return dayjs(value).format(format_str);
};
